export const updateAccessSelector = ({ access }) => access;

export const selectOfficeHoursPermission = (state) => {
    const permissions = state.access.access.nestedParentLevel
    .filter((v) => v.menuItemName.trim() === "Faculty Maintenance" && v.moduleorder === 13);
    
    return permissions.length > 0 ? permissions[0].menuAccess : 0;
}
export const selectPublicationsPermission = (state) => {
    const permissions = state.access.access.nestedParentLevel.filter((v) => v.menuItemName.trim() === "Faculty Maintenance" && v.moduleorder === 13);
    
    return permissions.length > 0 ? permissions[0].menuAccess : 0;
}

